import React from 'react';
import type { SimpleProgressCriterionData } from './challengeTypes';

const integerFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
const decimalFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

const formatValue = (value: number): string => {
  if (Number.isInteger(value)) return integerFormatter.format(value);
  return decimalFormatter.format(value);
};

interface Props {
  data: SimpleProgressCriterionData;
}

const SimpleProgressCriterion: React.FC<Props> = ({ data }) => {
  const { label, current, target, unit } = data;
  const suffix = unit ? ` ${unit}` : '';
  const pct = target > 0 ? Math.max(0, Math.min(1, current / target)) : 0;

  return (
    <div
      data-testid="challenge-criterion-simple-progress"
      className="rounded-[14px] bg-black/10 p-3 text-white"
    >
      <div className="flex items-baseline justify-between gap-3">
        <span className="text-sm font-bold">{label}</span>
        <span className="text-sm font-extrabold tabular-nums">
          {formatValue(current)}{suffix} / {formatValue(target)}{suffix}
        </span>
      </div>
      <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-white/20">
        <div
          className="h-full rounded-full bg-white transition-[width] duration-500 ease-out"
          style={{ width: `${pct * 100}%` }}
        />
      </div>
    </div>
  );
};

export default SimpleProgressCriterion;
